var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"tiktok_auth\"\u003E\u003Ch1\u003ERedirect\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;